import React from 'react';
import GuilgeeBalance from './guilgeeBalance';

const PageList = () => <GuilgeeBalance />;

export default PageList;
